import React from "react";

// Leyenda "Modificado por X el dd/mm/aaaa" — reutilizada en el pie de cada sección del
// expediente. Recibe el registro de auditoría (id_ultimousuario, ultimousuario, ultima_fecha)
// que traen todos los objetos de info_* de GetInfoClienteID. Siempre dice "Modificado",
// independientemente de si accion viene "C" (creado) o "M" (modificado).
export const CRM_LeyendaAuditoria = ({ auditoria, className = "" }) => {
  if (!auditoria?.ultimousuario || !auditoria?.ultima_fecha) return null;

  const fecha = new Date(auditoria.ultima_fecha).toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return (
    <div className={`crm-leyenda-auditoria${className ? ` ${className}` : ""}`}>
      Modificado por {auditoria.ultimousuario} el {fecha}
    </div>
  );
};
